<template>
    <div class="learning-box">
        <div class="editor-arrow">
            <route-back @click="routeBack" />
        </div>
        <div class="learning-box__body-head-wrapper">
            <router-view />
        </div>
    </div>
</template>

<script>
import RouteBack from "../../common/RouteBack";
const routing = ["menu", "information", "plan", "profit"];
export default {
    name: "EditorWrapPage",
    components: {
        RouteBack
    },
    props: {
        title: String,
        id: {},
        category: String
    },
    data() {
        return {
            prevRoute: null,
            routePath: ""
        };
    },
    beforeRouteEnter(to, from, next) {
        if (!localStorage.getItem("from")) {
            localStorage.setItem("from", from.fullPath);
        }
        next();
    },
    mounted() {
        this.routePath = localStorage.getItem("from");
    },
    methods: {
        routeBack() {
            let path = this.$route.fullPath;
            for (const r of routing) {
                if (path.match(r) && r === "menu") {
                    this.$router.push(this.routePath);
                } else {
                    this.$router.replace({ name: "editor-menu" });
                }
                break;
            }
        }
    },
    beforeDestroy() {
        localStorage.removeItem("from");
    }
};
</script>

<style scoped lang="scss">
@media (max-width: 768px) {
    .learning-box__body-head-wrapper {
        padding-top: 20px;
    }
    .editor-arrow {
        margin-top: 56px;
        padding: 10px;
        .learn-course__back {
            padding: 0;
        }
    }
}
</style>
